import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { FaCalendarPlus, FaStore, FaMusic } from "react-icons/fa";

const actions = [
  {
    key: "gathering",
    label: "Create a Gathering",
    icon: <FaCalendarPlus size={48} />,
    description: "Hosting an upcoming event? Click here to begin entering your information into your app.",
  },
  {
    key: "vendor",
    label: "Create a Vendor Profile",
    icon: <FaStore size={48} />,
    description: "Are you a vendor? Click here to create your vendor profile and connect with events.",
  },
  {
    key: "artist",
    label: "Create an Artist Profile",
    icon: <FaMusic size={48} />,
    description: "Are you an artist or performer? Click here to create your artist profile and join events.",
  },
];

const modalStyle = (isMobile) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  minWidth: 260,
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  outline: "none",
  maxHeight: "95vh",
  overflowY: "auto",
  maxWidth: "calc(100vw - 32px)",
});

const tooltipProps = {
  componentsProps: {
    tooltip: {
      sx: {
        fontSize: 18,
        padding: 2,
        maxWidth: 320,
        backgroundColor: "#f0f8ff",
        color: "#2183A6",
        border: "1px solid #2183A6",
        borderRadius: 2,
      },
    },
    arrow: {
      sx: {
        color: "#f0f8ff",
      },
    },
  },
};

const FirstTimeUserModal = ({ isOpen, onClose, onAction }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={modalStyle(isMobile)}>
        <Box sx={{ textAlign: "center", mb: isMobile ? 2 : 3 }}>
          <h2 style={{ fontSize: isMobile ? 22 : 28, margin: 0 }}>Welcome! Get Started:</h2>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "center",
            alignItems: "stretch",
            gap: isMobile ? 2 : 3,
            width: "100%",
          }}
        >
          {actions.map((action) => (
            <Tooltip
              key={action.key}
              title={action.description}
              placement="top"
              arrow
              enterDelay={200}
              {...tooltipProps}
            >
              <Button
                variant="outlined"
                onClick={() => onAction(action.key)}
                sx={{
                  width: isMobile ? "100%" : 180,
                  minHeight: isMobile ? 80 : 160,
                  flexDirection: "column",
                  borderRadius: 3,
                  borderWidth: 2,
                  fontSize: isMobile ? 16 : 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.5,
                  boxShadow: 2,
                  mb: 0,
                  transition:
                    "background 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s",
                  backgroundColor: "#2183A6",
                  borderColor: "#2183A6",
                  color: "#f7fbfd",
                  textTransform: "none",

                  "& svg": {
                    color: "#f7fbfd",
                  },

                  "&:hover": {
                    backgroundColor: "#2b95ba",
                    borderColor: "#2b95ba",
                    color: "#ffffff",
                    boxShadow: 4,
                  },

                  "&:hover svg": {
                    color: "#ffffff",
                  },
                }}
              >
                <span
                  style={{
                    fontSize: isMobile ? 32 : 48,
                    marginBottom: 8,
                    color: "inherit",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {action.icon}
                </span>

                <span
                  style={{
                    fontWeight: 500,
                    textAlign: "center",
                    color: "inherit",
                  }}
                >
                  {action.label}
                </span>
              </Button>
            </Tooltip>
          ))}
        </Box>
      </Box>
    </Modal>
  );
};

export default FirstTimeUserModal;